/* Strict mode is used for development purpose only and should be removed in production mode.
    But it is cause some bugs in development mode that's why we disabled it by default.
    If anyone want to used set it true */
export const useStrictMode = false;

export const GOOGLE_CLOUD_API_KEY = "AIzaSyAFApEXkq_FxTWGAVwEOEYxCtIxJ3iR9kU";
export const DEFAULT_MAP_POSITION = { lat: 29.761291, lng: -95.362869 };
export const STRIPE_PUBLIC_KEY = "pk_test_O6wiMgMeQ0vOb6q24zKjRCoK00ATArkfbL";

export const LOAD_TYPES = {
    "USA": [
        {
            value: "vehicle",
            label: "Vehicle",
        },
        {
            value: "pallet",
            label: "Pallet",
        },
        {
            value: "barrel",
            label: "Barrel",
        }
    ],
    "Ghana": [
        {
            value: "vehicle",
            label: "Vehicle",
        },
        {
            value: "stones",
            label: "Stones",
        },
        {
            value: "sand",
            label: "Sand",
        },
        {
            value: "laterite",
            label: "Laterite",
        },
    ],
    "Nigeria": [
        {
            value: "vehicle",
            label: "Vehicle",
        },
        {
            value: "stones",
            label: "Stones",
        },
        {
            value: "sand",
            label: "Sand",
        },
        {
            value: "laterite",
            label: "Laterite",
        },
    ]
}

